export default "__VITE_ASSET__313e967f__"